import { render, staticRenderFns } from "./testimonialItem.vue?vue&type=template&id=49f7b552&scoped=true&"
import script from "./testimonialItem.vue?vue&type=script&lang=js&"
export * from "./testimonialItem.vue?vue&type=script&lang=js&"
import style0 from "./testimonialItem.vue?vue&type=style&index=0&id=49f7b552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f7b552",
  null
  
)

export default component.exports